import React from "react";
import Formula from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Formula";
import OutcomeInput from "./OutcomeInput";
import ProxyType from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/ProxyTypes";
import ProxyTypes from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/ProxyTypes";

interface Props {
  formula: Formula;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, name: string, multiple?: boolean) => void;
  name: string;
  disabled?: boolean;
}

const FormulaInput = (props: Props) => {
  const { formula, onChange, name, disabled } = props;
  if (formula.getProxy() !== ProxyType.EVENT_REFERENCE && formula.getProxy() !== ProxyTypes.BBN_LINK_EXPRESSION) {
    throw new Error(`FormulaTextField formula proxy of type ${formula.getProxy()} is not supported`);
  }

  const outcome = formula.getOutcome();

  return (
    <OutcomeInput
      outcome={outcome}
      onChange={onChange}
      name={name}
      disabled={disabled}
    />
  )

};

export default FormulaInput;
